// frontend/src/stores/tariffInfo.js
// Какие функции доступны компании на её тарифе (источник: GET /api/tariff-info)
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from './auth'

export const useTariffInfoStore = defineStore('tariffInfo', () => {
  const info = ref(null)
  const loaded = ref(false)
  let pending = null

  async function load(force = false) {
    if (loaded.value && !force) return info.value
    if (pending && !force) return pending
    pending = api.get('/tariff-info')
      .then(({ data }) => { info.value = data; loaded.value = true; return data })
      .catch(() => { info.value = null; return null })
      .finally(() => { pending = null })
    return pending
  }

  // Пока данные не загружены или не получены, считаем функцию доступной: окончательную проверку делает сервер
  function has(feature) {
    if (!info.value || !info.value.features) return true
    return info.value.features[feature] === true
  }

  function reset() {
    info.value = null
    loaded.value = false
  }

  return { info, loaded, load, has, reset }
})
